import Authorities from '../Authority';
import { AuthorityBankingEntries } from '../Authority/Authority.BankingEntries';
import { AuthorityCRM } from '../Authority/Authority.CRM';
import { AuthorityConsumable } from '../Authority/Authority.Consumable';
import { AuthorityDashboard } from '../Authority/Authority.Dashboard';
import { AuthoritySale } from '../Authority/Authority.Sale';
import { AuthorityInvoice } from '../Authority/Authority.invoice';
import { COMBO_ON } from './Combo.On';

export const COMBO_PLUS = [
  ...COMBO_ON,

  ...Object.values(AuthorityConsumable),
  ...Object.values(AuthoritySale),
  ...Object.values(AuthorityBankingEntries),
  ...Object.values(AuthorityDashboard),
  ...Object.values(AuthorityCRM).filter((role) => !role.includes('10.1')),
  ...Object.values(AuthorityInvoice).filter(
    (role) => !role.match(/(11\.1|4\.2|4\.3)/g),
  ),

  // FISCAL INVOICES
  Authorities.FISCAL_INVOICE_VIEW_CARRIER,
  Authorities.FISCAL_INVOICE_CREATE_CARRIER,
  Authorities.FISCAL_INVOICE_UPDATE_CARRIER,
  Authorities.FISCAL_INVOICE_DELETE_CARRIER,

  // INTEGRATION FRAGA
  Authorities.DEFAULT_INTEGRATION_FRAGA,

  // WORKORDER
  Authorities.MOVIMENTATION_WORKORDER_GENERATE_INVOICE_TO_AUTHORIZED,
  Authorities.MOVIMENTATION_WORKORDER_ADD_EMPLOYEE_TO_COMMISSION,
  Authorities.MOVIMENTATION_WORKORDER_VIEW_COMMISSIONS_PAYMENT,
  Authorities.MOVIMENTATION_WORKORDER_CLOSED_ADD_COMMISSION,
  Authorities.MOVIMENTATION_WORKORDER_ADD_COMMISSION_PART_SUPPLIED,
  Authorities.MOVIMENTATION_WORKORDER_ADD_COMMISSION_THIRD_SERVICE,
  Authorities.MOVIMENTATION_WORKORDER_ITEM_ADD_BASE_COMMISSION_VALUE_GREATER_THAN_NET_VALUE,
  Authorities.MOVIMENTATION_WORKORDER_CHANGE_BASE_COMMISSION_VALUE,
  Authorities.MOVIMENTATION_WORKORDER_PRINT_ADMINISTRATIVE_REPORT,
  Authorities.MOVIMENTATION_WORKORDER_SEND_QUOTE_BY_EMAIL,
  Authorities.MOVIMENTATION_WORKORDER_FOLLOW_UP,
  Authorities.MOVIMENTATION_WORKORDER_VIEW_FOLLOW_UP_VALUES,

  // REPORT
  Authorities.REPORT_COMMISSION_VIEW,
  Authorities.REPORT_VIEW_MANAGERIAL_REPORTS,
  Authorities.REPORT_VIEW_BALANCE,
  Authorities.REPORT_VIEW_INVOICE_REPORTS,
  Authorities.REPORT_VIEW_DIRECT_SALES_REPORTS,

  // DEFAULT DASHBOARD
  Authorities.DEFAULT_MANAGERIAL_GRAPHICS,

  // COMPANY
  Authorities.REGISTER_COMPANY_DELETE,
  Authorities.REGISTER_COMPANY_ADD,

  // PARTSLINK24
  Authorities.MOVIMENTATION_PURCHASE_PARTSLINK24,

  // FISCAL SINTEGRA
  Authorities.FISCAL_INVOICE_GENERATE_SINTEGRA,
];
